import React from "react"
import _ from "lodash"
// Styles
import { Label_s } from 'styles/app-styles'
import { SingleRow_s } from 'components/table/hovers/hover-styles'

type IHover = {
  data: {}
  namedItems: {
    renewalProbability: {
      renewalprobabilityid: number
    }
  }
}

const RenewalProbHover = (props: IHover) => {
  const renewalDetail = _.get(props, "data.renewaldetail")

  if(_.get(renewalDetail, "state") === "basic") {
    return (
      <SingleRow_s>
        <div>
          <Label_s>Renewal Probability</Label_s>
          <span>{`${_.get(renewalDetail, "renewalProbability")}%`}</span>
        </div>
      </SingleRow_s>
    )
  } else if(_.get(renewalDetail, "state") === "namedItem"){
    const namedItem = _.find(props.namedItems.renewalProbability, (rp) => rp.renewalprobabilityid === _.get(renewalDetail, "renewalProbabilityNamedItemId"))
    return (
      <SingleRow_s>
        <div>
          <Label_s>Renewal Probability</Label_s>
          <span>{`${_.get(namedItem, "code")}`}</span>
        </div>
      </SingleRow_s>
    )
  } else return <span></span>
}

export default RenewalProbHover
